"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exchange = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var fyw_1 = require("../../model/fyw");
var service_1 = require("../../../library/base/service");
var Exchange = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Exchange, _super);
    function Exchange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '福员外积分兑换';
        _this.code = '107004';
        _this.desc = '福员外积分兑换';
        _this.requestParams = new fyw_1.ExchangeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Exchange;
}(service_1.BaseService));
exports.Exchange = Exchange;
//# sourceMappingURL=exchange.js.map